const pad = (value: number) => String(value).padStart(2, '0')

export const toUtcMidnight = (date: Date): Date =>
  new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0)
  )

export const formatUtcDateTime = (value: Date | string): string => {
  const date = new Date(value)

  return `${pad(date.getUTCDate())}-${pad(date.getUTCMonth() + 1)}-${String(
    date.getUTCFullYear()
  ).slice(-2)} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`
}
